// PROFESSIONAL — 23 tools in 4 blocks. Marker positions are card millimetres (mx from the face's left
// edge, my from its top); est:true = my authored guess, replaced the moment a mark is placed.
// hom: photo% -> card fraction per face. Both faces were locked onto the real engraving (0.99 each),
// the best calibration in the series — placing marks on the photos is as exact as placing them in 3D.
window.PROF = {
 "hom": {
  "A": [[0.01280329, -0.00555136, 0.13246926], [0.01184536, 0.01520763, -0.89673947], [0.00024366, 0.00003467, 1]],
  "B": [[0.0121098, 0.00377018, -0.2506832], [-0.0068226, 0.0149058, 0.1300279], [-0.0003124, 0.00040543, 1]]
 },
 "photo": {
  "A": "https://mrf.tools/cdn/shop/files/mrf26-prof-photo-a.jpg?v=b3",
  "B": "https://mrf.tools/cdn/shop/files/mrf26-prof-photo-b.jpg?v=b3"
 },
 "blocks": [
  {
   "name": "Rulers & scales",
   "tools": [
    {
     "n": 1,
     "cat": "MEASURE",
     "side": "A",
     "mx": 48.8,
     "my": 0,
     "est": false,
     "name": "Inch ruler",
     "desc": "3\" scale along the top edge in halves, quarters and eighths, ticks cut through the edge so you read against the work instead of beside it.",
     "sc": "Checking a print at 1:1 before it goes to the plotter."
    },
    {
     "n": 7,
     "cat": "MEASURE",
     "side": "B",
     "mx": 46.2,
     "my": 0,
     "est": false,
     "name": "Metric ruler",
     "desc": "80 mm along the back edge, millimetre ticks with every tenth numbered — the side you actually work in.",
     "sc": "Sizing a mount board margin at the framing counter."
    },
    {
     "n": 5,
     "cat": "TYPE",
     "side": "A",
     "mx": 70.6,
     "my": 46.8,
     "est": false,
     "name": "Pica scale",
     "desc": "Typographic picas along the bottom-left edge: 15, 12, 9, 6, 3 — the unit type is still set in.",
     "sc": "Reading a legacy spec sheet that quotes leading in picas."
    },
    {
     "n": 11,
     "cat": "TYPE",
     "side": "B",
     "mx": 72.5,
     "my": 45.5,
     "est": false,
     "name": "Pixel scale · 150 PPI",
     "desc": "Hold the card against a printed proof: the 150 PPI ladder reads pixel dimensions straight off the paper.",
     "sc": "Judging whether a web image will survive a desk print."
    },
    {
     "n": 2,
     "cat": "MEASURE",
     "side": "A",
     "mx": 0,
     "my": 0,
     "est": false,
     "name": "Tyre thread depth guide",
     "desc": "Stepped corner gauge in 32nds: drop it into a tread groove and read the remaining depth off the step that bottoms out.",
     "sc": "Deciding whether a tyre passes before a long drive."
    }
   ]
  },
  {
   "name": "Angles & compass",
   "tools": [
    {
     "n": 3,
     "cat": "ANGLE",
     "side": "A",
     "mx": 30,
     "my": 9,
     "est": true,
     "name": "Protractor",
     "desc": "Full 0–180° arc round the circle template, numbered every 10° with 1° ticks on the outer ring.",
     "sc": "Transferring an angle off a site sketch onto the drawing."
    },
    {
     "n": 6,
     "cat": "ANGLE",
     "side": "A",
     "mx": 0,
     "my": 51.8,
     "est": false,
     "name": "Precision protractor",
     "desc": "The narrow slotted arc at the edge: a pencil tip rides the slot, so the angle is drawn, not just read.",
     "sc": "Stepping out a repeating angle without re-setting the card."
    },
    {
     "n": 14,
     "cat": "ANGLE",
     "side": "A",
     "mx": 55.4,
     "my": 0,
     "est": false,
     "name": "Quick angle 30° · 45° · 60°",
     "desc": "Three engraved reference lines for the angles worth having by feel, so the card replaces a set square for a quick mark.",
     "sc": "Ruling a 45° crop line straight onto a print."
    },
    {
     "n": 19,
     "cat": "DRAW",
     "side": "A",
     "mx": 87.1,
     "my": 54,
     "est": false,
     "name": "Inch compass",
     "desc": "Pivot hole plus the radius holes down the ruler: pin the pivot, put the pencil in a hole and swing a circle in inches.",
     "sc": "Striking a 2\" arc with no compass in the bag."
    },
    {
     "n": 20,
     "cat": "DRAW",
     "side": "B",
     "mx": 1.2,
     "my": 6.8,
     "est": false,
     "name": "Metric compass",
     "desc": "The same trick in millimetres, holes spaced so the common radii come up without arithmetic.",
     "sc": "Drawing a ø60 mm circle on a layout sheet."
    },
    {
     "n": 8,
     "cat": "BUILD",
     "side": "B",
     "mx": 45.4,
     "my": 0,
     "est": false,
     "name": "Plumb bob",
     "desc": "Hang the card by the corner hole on a string — a true vertical reference, and the ruler edge gives you the offset.",
     "sc": "Checking a door frame before the hinges go on."
    }
   ]
  },
  {
   "name": "Drill & gauge",
   "tools": [
    {
     "n": 4,
     "cat": "DRILL",
     "side": "A",
     "mx": 19.6,
     "my": 10.1,
     "est": false,
     "name": "Inch drill guide",
     "desc": "Graded hole arc labelled in decimal inches — drop a bit in until it stops and you have its size without a caliper.",
     "sc": "Finding the right bit in a jar of unmarked ones."
    },
    {
     "n": 9,
     "cat": "DRILL",
     "side": "B",
     "mx": 14.6,
     "my": 15.1,
     "est": false,
     "name": "Metric drill guide",
     "desc": "The metric twin, 1.5 to 5.5 mm, each hole numbered on the arc.",
     "sc": "Matching a bit to a wall plug on site."
    },
    {
     "n": 15,
     "cat": "GAUGE",
     "side": "A",
     "mx": 87.1,
     "my": 13.5,
     "est": false,
     "name": "US sheet thickness gauge",
     "desc": "Slotted fan in American gauge numbers — 10ga to 20ga — for sheet steel and aluminium.",
     "sc": "Identifying sheet stock in a workshop offcut pile."
    },
    {
     "n": 22,
     "cat": "GAUGE",
     "side": "B",
     "mx": 87.1,
     "my": 18.6,
     "est": false,
     "name": "Sheet thickness gauge",
     "desc": "The metric fan: 1.0 to 4.0 mm slots, each labelled, for sheet and plate.",
     "sc": "Ordering a replacement panel in the right thickness."
    },
    {
     "n": 16,
     "cat": "DRAW",
     "side": "A",
     "mx": 44.1,
     "my": 19.6,
     "est": false,
     "name": "Circle template",
     "desc": "Five drawn circles — ø1/4\" to ø1/2\" on the imperial face, ø6 to ø12 mm on the metric one — each labelled at its edge.",
     "sc": "Rounding a corner radius by hand, twice the same size."
    },
    {
     "n": 13,
     "cat": "DRIVE",
     "side": "A",
     "mx": 76.9,
     "my": 5.3,
     "est": false,
     "name": "1/4\" hex bit driver",
     "desc": "Hex socket for a standard ¼\" bit — the card becomes the handle.",
     "sc": "Driving a screw with a loose bit from a workshop drawer."
    }
   ]
  },
  {
   "name": "Squares & desk",
   "tools": [
    {
     "n": 17,
     "cat": "DRAW",
     "side": "A",
     "mx": 85.5,
     "my": 49.9,
     "est": false,
     "name": "Inch L-square",
     "desc": "The right edge carries a perpendicular inch scale: two edges at a true 90° make the card a small try square.",
     "sc": "Squaring a mat cut on a cutting mat with no rule to hand."
    },
    {
     "n": 10,
     "cat": "DRAW",
     "side": "B",
     "mx": 0,
     "my": 53.2,
     "est": false,
     "name": "Metric L-square",
     "desc": "Same corner in millimetres — 0 at the corner, so you measure and square in one move.",
     "sc": "Marking a 20 mm border on a sheet, square to the edge."
    },
    {
     "n": 24,
     "cat": "DRAW",
     "side": "B",
     "mx": 50,
     "my": 52,
     "est": true,
     "name": "Quick parallel lines",
     "desc": "Edge notches at fixed spacing: run a pencil in a notch, slide the card along a straightedge and the lines come out parallel.",
     "sc": "Ruling guide lines for hand lettering without a T-square."
    },
    {
     "n": 18,
     "cat": "DESK",
     "side": "A",
     "mx": 50,
     "my": 44,
     "est": true,
     "name": "Phone stand",
     "desc": "The long slot takes a phone's edge and holds it at reading angle — the card props your reference while you draw.",
     "sc": "Keeping a reference photo upright next to the sketchbook."
    },
    {
     "n": 12,
     "cat": "CUT",
     "side": "A",
     "mx": 84,
     "my": 3,
     "est": true,
     "name": "Box opener",
     "desc": "Hooked corner notch that catches packing tape and cuts it as you pull, without a blade near the contents.",
     "sc": "Opening a parcel at the studio door."
    },
    {
     "n": 21,
     "cat": "CAMP",
     "side": "B",
     "mx": 85,
     "my": 10,
     "est": true,
     "name": "Bottle opener",
     "desc": "Marked cap lifter on the right edge, sized so the card doesn't twist in your fingers.",
     "sc": "The end of a long day at the drawing board."
    }
   ]
  }
 ]
};
